import React, { useMemo } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import AgentWantAdForm from "../components/AgentWantAdForm";
import { AGENT_WANTAD_KEY } from "@/constants/common";
import { getWantAdById } from "@/services/v2/wantAdService";
import { getLocalStorage } from "@/helpers/common";
import Loader from "../components/Common/Loader";
import _ from "lodash"

const AgentEditWantAd = () => {

  const { id } = useParams();
  const location = useLocation();

  const isFromConfirmationPage =
    location.state && location.state["isFromConfirmationPage"] ? true : false;
  const stateData = location.state?.data;

  // The confirmation round-trip and in-app navigation both carry the want-ad
  // with them, so only a cold load actually has to read it back.
  const shouldFetch = !isFromConfirmationPage && !stateData && !!id;

  const wantAdQuery = useQuery({
    queryKey: ["agentEditWantAd", id],
    queryFn: async () => {
      const response = await getWantAdById(id);
      const responseResult = _.get(response, "result", null);
      return response.errorCode === 0 && responseResult ? responseResult : null;
    },
    enabled: shouldFetch,
    // The form is seeded from this payload, so it must never open on a cached
    // copy of a want-ad the user just edited.
    staleTime: 0,
    // Matches the previous behaviour: a failed read fell straight through to an
    // empty form rather than retrying.
    retry: false,
  });

  const confirmationData = useMemo(
    () =>
      isFromConfirmationPage ? getLocalStorage(AGENT_WANTAD_KEY) : null,
    [isFromConfirmationPage],
  );

  const fetchedWantAd = wantAdQuery.data ?? null;
  const showPublished = fetchedWantAd?.isPublished === 1;

  if (shouldFetch && wantAdQuery.isPending) {
    return <Loader />;
  }

  if (showPublished) {
    return (
      <div className="row m-0">
        <h2 className="text-center">Want-Listing already published</h2>
      </div>
    );
  }

  const wantAdData = isFromConfirmationPage
    ? confirmationData
    : stateData || fetchedWantAd;

  return <AgentWantAdForm initialData={wantAdData} isEdit={true} />;
};

export default AgentEditWantAd;
